import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISliderScaleProps from "./type";
import stylesheet, {
    getSliderScaleLabelWidths,
    getSliderScaleLabelStyle,
    getSliderScaleTickStyle,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Text from "../../../text";

const SliderScale: FC<ISliderScaleProps> = ({
    currentMeasures,
    currentColors,
    customTheme,
    labels,
    length,
    ticks
}) => {
    const {
        typography,
        radiuses,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const usable = Math.max(length - currentMeasures.thumbSize, 0);

    const {
        container: containerDynamicStyle,
        labels: labelsDynamicStyle,
        ticks: ticksDynamicStyle
    } = useStyles({
        currentMeasures,
        typography,
        borders,
        spaces
    });

    const labelWidths = getSliderScaleLabelWidths({
        labels,
        usable
    });

    const renderTicks = () => {
        if(!ticks.length) {
            return null;
        }

        return <View
            style={[
                stylesheet.ticks,
                ticksDynamicStyle
            ]}
        >
            {
                ticks.map((tick) => <View
                    style={[
                        stylesheet.tick,
                        getSliderScaleTickStyle({
                            currentMeasures,
                            currentColors,
                            radiuses,
                            borders,
                            usable,
                            tick
                        })
                    ]}
                    key={tick.fraction}
                />)
            }
        </View>;
    };

    const renderLabels = () => {
        if(!labels.length) {
            return null;
        }

        return <View
            style={[
                stylesheet.labels,
                labelsDynamicStyle
            ]}
        >
            {
                labels.map((label, index) => <View
                    style={[
                        stylesheet.label,
                        label.align === "center" ? null : stylesheet.edgeLabel,
                        getSliderScaleLabelStyle({
                            width: labelWidths[index] ?? 0,
                            currentMeasures,
                            usable,
                            label
                        })
                    ]}
                    key={`${label.fraction}-${label.text}`}
                >
                    <Text
                        style={[
                            stylesheet.labelText,
                            label.align === "center" ? stylesheet.centerLabel : null
                        ]}
                        customColor={currentColors.valueColor}
                        customTheme={customTheme}
                        variant="bodySmallSize"
                        numberOfLines={1}
                    >
                        {label.text}
                    </Text>
                </View>)
            }
        </View>;
    };

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {renderTicks()}
        {renderLabels()}
    </View>;
};
export default SliderScale;
